import { Box } from '@mui/material'
import { ItemImageAreaSkeleton } from 'utoniq-ui'

import { Cell } from '@/core/architecture'

type ItemBoxSkeletonProps = {}

export const ItemBoxSkeleton: Cell<ItemBoxSkeletonProps> = () => (
  <Box>
    <ItemImageAreaSkeleton />
  </Box>
)
